import { render, staticRenderFns } from "./UpgradeModal.vue?vue&type=template&id=5a264914&scoped=true"
import script from "./UpgradeModal.vue?vue&type=script&lang=ts"
export * from "./UpgradeModal.vue?vue&type=script&lang=ts"
import style0 from "./UpgradeModal.vue?vue&type=style&index=0&id=5a264914&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a264914",
  null
  
)

export default component.exports